import {useEffect, useRef, useCallback} from 'react'
import useTpaMarketingConsent from '~/app/hooks/use-tpa-marketing-consent'
import {trackConsentForSegment} from './eventHandlers'
import {consentEventCategories, sessionKeys} from './constants'
import {formatSiteName} from '../helpers'
import {isClient} from 'hec/utils/common'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

export const TpaConsentTracker = () => {
    const {canTrackMarketingEvents, isTpaUser, onConsentChange} = useTpaMarketingConsent()
    const {site} = useMultiSite()
    const lastConsentState = useRef(null)
    const hasTrackedInitial = useRef(
        typeof window !== 'undefined' &&
            sessionStorage.getItem(sessionKeys.consentTracked) === 'true'
    )

    const trackConsent = useCallback(
        (placement) => {
            const canTrack = canTrackMarketingEvents()
            if (lastConsentState.current === canTrack || !canTrack) return

            const acceptAction = 'accept'
            const formattedSiteName = formatSiteName(site.id)

            trackConsentForSegment({
                category: formattedSiteName + consentEventCategories.hecMarketingEmail,
                action: acceptAction,
                placement
            })
            trackConsentForSegment({
                category: formattedSiteName + consentEventCategories.hecSaleEmail,
                action: acceptAction,
                placement
            })
            if (site.id === 'HSASTORE') {
                trackConsentForSegment({
                    category: formattedSiteName + consentEventCategories.hecEducationEmail,
                    action: acceptAction,
                    placement
                })
            }

            lastConsentState.current = canTrack
        },
        [canTrackMarketingEvents, site.id]
    )

    useEffect(() => {
        if (!isClient) return

        if (isTpaUser) {
            if (!hasTrackedInitial.current) {
                trackConsent('tpa-initial-load')
                hasTrackedInitial.current = true
                sessionStorage.setItem(sessionKeys.consentTracked, 'true')
            }
            const unsubscribe = onConsentChange(() => trackConsent('tpa-consent-change'))
            return () => {
                unsubscribe?.()
            }
        }
    }, [canTrackMarketingEvents, isTpaUser, trackConsent, onConsentChange])

    return null
}
